import { joinPathsStringUtil } from 'packages/src'

export default function getQueryDomainListPathReduxUtil (domainListPath, query) {
  if (!domainListPath) {
    return domainListPath
  }
  if (query) {
    domainListPath = joinPathsStringUtil(domainListPath, query.toLowerCase())
  }
  return domainListPath
}
